export const MIN_SELECTABLE_ENTRIES = 2;
